import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { Environment } from 'fym-common/src/config/types';
import { config } from '../config/config';

export const TRPCDevTools = () => {
  // Hidden in production AND uitest — the devtools button would otherwise land in the
  // desktop (Electron/web) App Store / website screenshots.
  if (config.environment === Environment.production || config.environment === Environment.uitest) {
    return null;
  }
  return (
    <div style={{ position: 'fixed', right: 50, bottom: 10, zIndex: 2000 }}>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="relative" />
    </div>
  );
};
